import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {BookmarkButton, Alert} from './'
import {CounterfeitsCardStyle} from './../styles'

export default class AlertCard extends Component {
  render() {
    const { slug, title, slug_bookmark, type, is_bookmark } = this.props
     return (
      <Link to={`/user/alerts${slug}`} className={` ${CounterfeitsCardStyle} counterfeit flex `}>
        <div className="counterfeit-title"><Alert width={24} height={24} /> {title } </div>
        
        { 
          slug_bookmark && 
          <div className="counterfeit-bookmark"> 
            <BookmarkButton item={{ slug_bookmark, type: type}} is_bookmark={ is_bookmark} />
          </div>
        }
        <div className="counterfeit-link"> Read more </div>
      </Link>
     )
  }
}


// WEBPACK FOOTER //
// ./src/components/AlertCard.js